import { Button } from "@mui/material";
import default_theme from "assets/themes/themes";

const AddButton = ({ children, sx = {}, ...props }) => (
  <Button
    variant="contained"
    sx={{
      backgroundColor: default_theme.palette.other.addButtonBlue,
      color: default_theme.palette.primary.main,
      borderColor: default_theme.palette.other.figmaBlue,
      "&:hover": {
        backgroundColor: default_theme.palette.other.figmaBlue,
        color: default_theme.palette.primary.main,
        borderColor: default_theme.palette.other.addButtonBlue,
        opacity: 0.9,
      },
      ...sx,
    }}
    {...props}
  >
    {children}
  </Button>
);

export default AddButton;